export const MAX_TEAMS = 10;
export const DEBOUNCE_TIME_MS = 150;
export const CONTRIBUTING_TEAM_PICKER_ID = 'ContributingTeamPicker';
